import React from 'react';
import { logout } from './Authentication'; // Adjust the import path if needed

function LogoutButton() {
    const user = JSON.parse(localStorage.getItem('user')); // Parse the user object from local storage
    const id = user ? user.OrgUniqueName : null; // Get orgUniquename

    const handleLogout = () => {
        if (id) {
            logout(id); // Call logout with the id
        } else {
            console.error("User ID not found in localStorage.");
        }
    };

    return (
        <li class="nav-item">
                    <a class="nav-link" href={`/Login/${id}`} role="button" onClick={handleLogout}>
                        <i class="fas fa-power-off"></i>
                    </a>
                </li>
        // <button onClick={handleLogout} type="button" className="btn btn-block btn-danger" style={{ margin: 'auto' }}>
        //     Logout
        // </button>
    );
}

export default LogoutButton;
